import { toast as sonnerToast } from 'vue-sonner'

type LegacyToastVariant = 'default' | 'destructive' | 'outline' | 'success' | 'warning' | 'info'

type LegacyToastOptions = {
  title?: string
  description?: string
  variant?: LegacyToastVariant
  [key: string]: unknown
}

type ToastInput = string | LegacyToastOptions

const toMessage = (options: LegacyToastOptions) => options.title ?? options.description ?? ''

const toDescription = (options: LegacyToastOptions) =>
  options.title ? options.description : undefined

const buildData = (options: LegacyToastOptions) => {
  const { title, description, variant, ...rest } = options
  return { description: toDescription(options), ...rest }
}

export const toast = (input: ToastInput) => {
  if (typeof input === 'string') {
    return sonnerToast(input)
  }

  const message = toMessage(input)
  const data = buildData(input)

  switch (input.variant) {
    case 'destructive':
      return sonnerToast.error(message, data)
    case 'success':
      return sonnerToast.success(message, data)
    case 'warning':
      return sonnerToast.warning(message, data)
    case 'info':
      return sonnerToast.info(message, data)
    default:
      return sonnerToast(message, data)
  }
}
